import { Avatar } from '@/primitives/Avatar';

export type SubtenantSelectLabelProps = {
  label: string;
  isLoading?: boolean;
};

export function SubtenantSelectLabel({ label, isLoading }: SubtenantSelectLabelProps) {
  const firstLetter = label.charAt(0).toUpperCase();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div
          style={{
            width: '20px',
            height: '20px',
            backgroundColor: '#f0f0f0',
            borderRadius: '2px',
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
        <span style={{ opacity: 0.7 }}>Loading...</span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Avatar size="xs" text={firstLetter} shape="square" />
      {label}
    </div>
  );
}
